import { useTranslation } from 'next-i18next';
import { Chip } from '@components/common';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import { dataTestId } from '@services/data-test-id';


// Interface
// **************************************
interface OpenSidebarFiltersGroupProps {
  toggleDrawer?: () => void,
}

/**
 * @description The open filters group component. It contains a stylized button that opens the sidebar filters and also
 * the sidebar filters themselves.
 * ***toggleDrawer** - the function to toggle the drawer.
 */
export const OpenSidebarButton = (props: OpenSidebarFiltersGroupProps) => {
  // Destructure props
  const {
    toggleDrawer,
  } = props;

  // Translation
  const { t } = useTranslation('common');

  // Render component
  // **********************************************
  return (
    <Chip onClick={toggleDrawer} icon={<AdjustmentsHorizontalIcon />} {...dataTestId('cvSearchPage.filtersButton')}>
      {t('filters.filters-nav.filter-button-label')}
    </Chip>
  );
};
